const SettingsFields = [
  { label: "Latitude", name: "latitude" },
  { label: "Longitude", name: "longitude" },
  { label: "Login Range", name: "loginRange" },
  { label: "Multiple Currencies", name: "hasMultipleCurrencies", switch: true },
  { label: "OdooSLB", name: "odooJournalEntry", switch: true },
  { label: "Pay Online", name: "payOnline", switch: true },
  { label: "CC Number Required", name: "ccNumberRequired", switch: true },
];

export default SettingsFields;